import {
  Component,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { originalOrder } from 'src/app/shared/pipes/keyvalue-pipe-sort';
import { LanguageCodesService } from 'src/app/shared/services/language-codes.service';
import { SubSink } from 'subsink';

import {
  MerchantSiteViewModel,
  OpeningHoursOfDayViewModel,
} from '@app/api/models';

import { MerchantActions } from '../../store/merchant.slice';
import { OpeningHoursViewModel } from './../../../api/models/opening-hours-view-model';

@Component({
  selector: 'app-merchant-site-card',
  templateUrl: './merchant-site-card.component.html',
  styleUrls: ['./merchant-site-card.component.scss'],
})
export class MerchantSiteCardComponent implements OnDestroy, OnChanges {
  TITLE = 'MERCHANT.TITLE.';
  @Input() site!: MerchantSiteViewModel;
  @Input() readOnly?: boolean;

  private subs = new SubSink();

  constructor(
    private languageCodesService: LanguageCodesService,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  DAYS = 'SHARED.OPENING_HOURS.DAYS.';

  byDay = originalOrder;

  openingHours?: Array<{ day: string; opening: OpeningHoursOfDayViewModel }>;

  showMoreActive = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['site'].firstChange) {
      this.getOpeningHours(this.site.openingHours);
    }
  }

  getLangNameByCode(code: string): string {
    return this.languageCodesService.getNameByCode(code);
  }

  delete() {
    this.store.dispatch(
      MerchantActions.deleteSite.trigger({ id: this.site.id })
    );
  }

  edit() {
    this.router.navigate(['edit'], {
      queryParams: { id: this.site.id },
      relativeTo: this.route,
    });
  }

  getOpeningHours(openingHours?: OpeningHoursViewModel) {
    if (openingHours) {
      this.openingHours = Object.keys(openingHours).map((day, idx) => {
        return {
          day: day,
          opening: Object.values(openingHours)[idx],
        };
      });
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
